import React from 'react';
import { Grid } from '@mui/material';
import { ExerciseGroupedSet } from '@/common/types';
import { SetInfoTable } from '../SetInfoTable/SetInfoTable';
import { ExerciseSetWrapper, ExerciseSetTitle } from './styles';

interface Props {
    exerciseSet: ExerciseGroupedSet;
}
export const ExerciseTimeSet = (props: Props) => {
    const { exerciseSet } = props;

    let totalTime = 0;
    let completeTime = 0;
    let setsStarted = 0;
    const setInfoTables = exerciseSet.sets.map((set, i) => {
        totalTime += set.setInfo.timeGoal ? set.setInfo.timeGoal : 0;
        completeTime += set.setInfo.timeComplete ? set.setInfo.timeComplete : 0;
        setsStarted += (set.setInfo.timeComplete || 0) > 0 || set.setInfo.maxROM ? 1 : 0;
        // eslint-disable-next-line react/no-array-index-key
        return <SetInfoTable set={set} i={i} key={i} />;
    });

    return (
        <ExerciseSetWrapper>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <ExerciseSetTitle>Set</ExerciseSetTitle>
                </Grid>
                <Grid item xs={4}>
                    <ExerciseSetTitle>Time</ExerciseSetTitle>
                </Grid>
                <Grid item xs={4}>
                    <ExerciseSetTitle>Errors</ExerciseSetTitle>
                </Grid>
            </Grid>
            <>{setInfoTables}</>
        </ExerciseSetWrapper>
    );
};
